import InvestorProjectDetailsPage from "./InvestorProjectDetailsPage"

export default InvestorProjectDetailsPage
